import React from 'react';
import { Link } from 'react-router-dom';
export function ThankYouPage() {
  return <div className="min-h-screen bg-[#0A1628] flex flex-col font-sans" data-id="element-142">
      {/* Navigation - Sticky */}
      <nav className="fixed top-0 left-0 w-full z-50 border-b border-white/10 bg-[#0A1628]/95 backdrop-blur-md" data-id="element-143">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-144">
          <div className="flex items-center justify-between h-24" data-id="element-145">
            <div className="flex items-center" data-id="element-146">
              <Link to="/" data-id="element-147">
                <img src="https://cdn.magicpatterns.com/uploads/d5Rt2q5xxrBaS9DBEGb4aS/Dealers-Choice-Solutions-Logo-(Dark-Blue-BG).png" alt="DealersChoice Solutions" className="h-16 lg:h-20 w-auto" data-id="element-148" />
              </Link>
            </div>
            {/* Intentionally no button here per requirements */}
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main className="flex-grow flex items-center justify-center pt-24 px-4" data-id="element-149">
        <div className="text-center max-w-3xl mx-auto" data-id="element-150">
          <h1 className="text-5xl md:text-7xl font-bold text-[#D4AF37] italic font-playfair mb-8" data-id="element-151">
            Thank You!
          </h1>

          <div className="w-16 h-1 bg-[#D4AF37] mx-auto mb-8" data-id="element-152"></div>

          <h2 className="text-xl md:text-2xl font-bold text-white mb-4" data-id="element-153">
            Your request has been received.
          </h2>

          <p className="text-gray-400 text-lg max-w-lg mx-auto leading-relaxed" data-id="element-154">
            One of our marine marketing specialists will be in touch with you
            shortly. We look forward to helping grow your dealership.
          </p>
        </div>
      </main>
    </div>;
}